export default "__VITE_ASSET__2e06de4b__"